import { createFileRoute, Navigate, Outlet, redirect } from '@tanstack/react-router';

import { OnboardingProvider } from '@src/pages/Onboarding';
import { useMineQuery } from '@src/query';

export const Route = createFileRoute('/onboarding')({
  beforeLoad: async ({ context, location }) => {
    const { auth } = context;
    try {
      await auth.verifyToken();
    }
    catch {
      try {
        await auth.refreshToken();
      }
      catch {
        throw redirect({
          to: '/auth/login',
          search: {
            redirect: encodeURIComponent(location.href),
          },
        });
      }
    }
  },
  component: Onboarding,
});

function Onboarding() {
  const { data: memberships, isSuccess } = useMineQuery();

  // Mirror of the /app no-org redirect: a user who already belongs to an org has
  // no business in the wizard (e.g. login bounced back here via ?redirect).
  if (isSuccess && memberships?.length > 0) {
    return <Navigate replace to="/app/dashboard" />;
  }

  return (
    <OnboardingProvider>
      <Outlet />
    </OnboardingProvider>
  );
}
